import axios from "axios";
import jwt_decode from "jwt-decode";
import { userLogout } from "../features/actions/authAsyncAction";
import { toast } from "react-toastify";

/**
 * ==============================================
 * Base URL Configuration
 * ==============================================
 */

// Two different production URLs
const PRODUCTION_URL_NF1 = "https://netfeebd.net/api/v1/";
const PRODUCTION_URL_NF2 = "https://netfee.top/api/v1/";

// Development URL (for local testing)
// const DEV_URL_NF1 = PRODUCTION_URL_NF1;
// const DEV_URL_NF2 = PRODUCTION_URL_NF2;

const DEV_URL_NF1 = "http://localhost:9099/api/v1/";
const DEV_URL_NF2 = "http://localhost:9099/api/v1/";

// Automatically choose environment
const URL_NF1 =
  process.env.NODE_ENV === "production" ? PRODUCTION_URL_NF1 : DEV_URL_NF1;

const URL_NF2 =
  process.env.NODE_ENV === "production" ? PRODUCTION_URL_NF2 : DEV_URL_NF2;

/**
 * ==============================================
 * Axios Instances
 * ==============================================
 */

export const publicRequest = axios.create({
  baseURL: URL_NF1,
});

const BASE_URL_NF1 = axios.create({
  baseURL: URL_NF1,
});

const BASE_URL_NF2 = axios.create({
  baseURL: URL_NF2,
});

const PUBLIC_BASE_URL_NF2 = axios.create({
  baseURL: URL_NF2,
});

/**
 * ==============================================
 * Token & Error Handling Interceptor
 * ==============================================
 */
const attachInterceptors = (apiInstance) => {
  // Request Interceptor
  apiInstance.interceptors.request.use(
    async (config) => {
      const TOKEN = JSON.parse(localStorage.getItem("netFeeToken"));

      if (!TOKEN) {
        userLogout();
        localStorage.removeItem("netFeeToken");
        return Promise.reject("No Token Found");
      }

      const currentDate = new Date();
      const decodedToken = jwt_decode(TOKEN);

      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        userLogout();
        return Promise.reject("Token Expired");
      }

      config.headers["authorization"] = "Bearer " + TOKEN;
      return config;
    },
    (error) => Promise.reject(error),
  );

  // Response Interceptor
  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        toast.error(error.response?.data?.message || "Unauthorized Access");
        setTimeout(() => userLogout(), 500);
      }
      return Promise.reject(error.response?.data || error);
    },
  );
};

// Attach interceptors to both APIs
attachInterceptors(BASE_URL_NF1);
attachInterceptors(BASE_URL_NF2);

/**
 * ==============================================
 * Export Instances
 * ==============================================
 */

export { BASE_URL_NF1, BASE_URL_NF2, PUBLIC_BASE_URL_NF2 };
